import Vue from "vue";
import i18n from "@/plugins/i18n";
import vuetify from "@/plugins/vuetify";

import VuetifyDialog from "vuetify-dialog";
import "vuetify-dialog/dist/vuetify-dialog.css";

Vue.use(VuetifyDialog, { context: { vuetify, i18n } });
